import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import { Tabs, Tab } from 'material-ui/Tabs'
import Associations from '../associations'

const associationFields = [
  { name: 'User', prop: 'user_id', type: 'autocomplete', references: 'admin/users', referenceProp: 'fullname', displayProp: 'name' }
]

const associationColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Name', prop: 'name' },
  { name: 'Email', prop: 'email' }
]

const EditGroup = (props) => {
  return (
    <Tabs>
      <Tab label='Edit Group'>
        <Edit
// @ts-ignore
          title='Edit Group'
          fields={fields}
          apiPath={`admin/groups/${props.params.groupId}`}
          successRedirectPath='/write-now/groups'
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Merge Fields'>
        <Edit
// @ts-ignore
          title='Merge Fields'
          fields={[
            { name: 'Group Number', prop: 'group_number', type: 'text' },
            { name: 'Coach Name', prop: 'coach_name', type: 'text' },
            { name: 'Head Coach Name', prop: 'head_coach_name', type: 'text' },
            { name: 'Head Coach Email', prop: 'head_coach_email', type: 'text' },
            { name: 'Meeting Link', prop: 'meeting_link', type: 'text' },
            { name: 'Meeting ID', prop: 'meeting_id', type: 'text' },
            { name: 'Meeting Passcode', prop: 'meeting_passcode', type: 'text' },
            { name: 'Meeting Time', prop: 'meeting_time', type: 'text' },
            { name: 'Group Merge Field 1', prop: 'group_merge_field_1', type: 'text' },
            { name: 'Group Merge Field 2', prop: 'group_merge_field_2', type: 'text' },
            { name: 'Group Merge Field 3', prop: 'group_merge_field_3', type: 'text' }
          ]}
          apiPath={`admin/groups/${props.params.groupId}/merge_fields`}
          successRedirectPath='/write-now/groups'
          disableDelete
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Members'>
        <Associations
// @ts-ignore
          title='Members'
          fields={associationFields}
          columns={associationColumns}
          baseRecord={{ group_id: props.params.groupId, coach_role: null }}
          joinApiPath='admin/group_users'
          associationApiPath='admin/users'
          joinApiQuery={{ 'filters[group_id]': props.params.groupId, 'filters[coach_role]': null }}
          associationIdField='user_id'
          viewAssociation={({ id }) => `/write-now/members/${id}/edit`}
        />
      </Tab>
      <Tab label='Coaches'>
        <Associations
// @ts-ignore
          title='Coaches'
          fields={associationFields}
          columns={associationColumns}
          baseRecord={{ group_id: props.params.groupId, coach_role: 'coach' }}
          joinApiPath='admin/group_users'
          associationApiPath='admin/users'
          joinApiQuery={{ 'filters[group_id]': props.params.groupId, 'filters[coach_role]': 'coach' }}
          associationIdField='user_id'
        />
      </Tab>
      <Tab label='Head Coaches'>
        <Associations
// @ts-ignore
          title='Head Coaches'
          fields={associationFields}
          columns={associationColumns}
          baseRecord={{ group_id: props.params.groupId, coach_role: 'head_coach' }}
          joinApiPath='admin/group_users'
          associationApiPath='admin/users'
          joinApiQuery={{ 'filters[group_id]': props.params.groupId, 'filters[coach_role]': 'head_coach' }}
          associationIdField='user_id'
        />
      </Tab>
    </Tabs>
  )
}

export default EditGroup
